import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PageHeader({
  title,
  subtitle,
  actions,
  actionsClassName,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Classes ajoutées au bloc d'actions (ex. `max-sm:hidden`). */
  actionsClassName?: string;
}) {
  return (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-2xl sm:text-3xl font-bold text-[var(--color-navy-700)] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className={cn("flex flex-wrap items-center gap-2", actionsClassName)}>{actions}</div>}
    </div>
  );
}
